import * as api from '../connectivity/api.users';
import { call, put } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import * as types from '../constants/actionTypes';
import { showLoading, hideLoading } from 'react-redux-loading-bar';


export function* doRequestDropboxUsers(action) {
    yield put(showLoading());

    try {
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'users.doRequestDropboxUsers',
            }
        });

        const { dropboxId }  = action.payload,
            users = yield call(api.fetchDropboxUsers, dropboxId)
        ;

        yield put({
            type: types.DROPBOX__USERS__REQUESTED__SUCCEEDED,
            payload: {
                users,
                dropbox: dropboxId,
            },
        });

    } catch (e) {
        yield put({
            type: types.DROPBOX__USERS__REQUESTED__FAILED,
            message: e.message
        });
    }

    yield put({
        type: types.REQUEST__FINISHED,
        payload: {
            requestFrom: 'users.doRequestDropboxUsers'
        }
    });

    yield put(hideLoading());
}

export function* doRequestDropboxUsersSucceeded() {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'users.doRequestDropboxUsers'
        }
    });
}

export function* doRequestDropboxUsersFailed() {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'users.doRequestDropboxUsers'
        }
    });
}

export function* watchRequestDropboxUsers() {
    yield* takeLatest(types.DROPBOX__USERS__REQUESTED, doRequestDropboxUsers);
}

export function* watchRequestDropboxUsersSucceeded() {
    yield* takeLatest(types.DROPBOX__USERS__REQUESTED__SUCCEEDED, doRequestDropboxUsersSucceeded);
}

export function* watchRequestDropboxUsersFailed() {
    yield* takeLatest(types.DROPBOX__USERS__REQUESTED__FAILED, doRequestDropboxUsersFailed);
}


/** WEBPACK FOOTER **
 ** ./src/sagas/users.saga.js
 **/